"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AppBack = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/arrow--left/32.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".app-back {\n  display: block;\n  margin: 0 auto 3rem auto; }\n  .app-back:hover {\n    cursor: pointer; }\n";
  const fileName = "AppBack_AppBack";
  const element = document.querySelector("style[data-sass-component='AppBack_AppBack']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const AppBack = props => {
  return /*#__PURE__*/_react.default.createElement(_.default, {
    className: 'app-back',
    onClick: props.onClick
  });
};
exports.AppBack = AppBack;
AppBack.propTypes = {
  onClick: _propTypes.default.func.isRequired
};
var _default = exports.default = AppBack;